var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 498,
    height: 422,
    fill: "none",
    viewBox: "0 0 498 422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.541
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)",
    opacity: 0.568
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.598,
    cy: 211.114,
    fill: "url(#paint0_linear)",
    rx: 113,
    ry: 73.676,
    transform: "rotate(-6 248.598 211.114)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)",
    opacity: 0.476
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B60E4A",
    fillRule: "evenodd",
    d: "M180.098 206.694l29.74 16.641 55.535-3.678 21.265-12.082 17.473-.182-29.066-27.99-30.629-.365-24.196 5.944-40.122 21.712z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_radial)",
    fillRule: "evenodd",
    d: "M296.776 198.509c-45.977 16.974-97.919-38.318-109.722 19.074-11.802 57.392-4.309 68.1-37.44 77.329-33.13 9.229-78.134-121.803-78.134-121.803l100.752-96.548 160.069-40.22s10.453 145.195-35.525 162.168z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    width: 497.126,
    height: 420.287,
    x: 0.035,
    y: 0.971,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 67.957
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    width: 227.308,
    height: 147.591,
    x: 128.45,
    y: 127.391,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur",
    stdDeviation: 25.824
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-121.566 177.71 34.89) scale(130.31 142.924)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFF",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 135.598,
    x2: 135.598,
    y1: 137.438,
    y2: 284.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB7272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2691D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA2);
export default __webpack_public_path__ + "static/media/a2.8d65883e77fc70acd8b68000c9bbae7c.svg";
export { ForwardRef as ReactComponent };